;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('SendInvoiceController', SendInvoiceController)

  SendInvoiceController.$inject = [
    // Angular
    '$uibModalInstance',

    // Managers
    'DefaultInvoiceTemplateManager', 'InvoiceTemplateManager',
    'DefaultQuoteTemplateManager', 'QuoteTemplateManager',
    'DefaultCreditNoteTemplateManager', 'CreditNoteTemplateManager',
    'EmailTemplateManager',

    // Services
    'PreferencesService', 'EmailService',

    // Resolve
    'obj', 'type', 'asInter'

  ]

  function SendInvoiceController (
    // Angular
    $uibModalInstance,

    // Managers
    DefaultInvoiceTemplateManager, InvoiceTemplateManager,
    DefaultQuoteTemplateManager, QuoteTemplateManager,
    DefaultCreditNoteTemplateManager, CreditNoteTemplateManager,
    EmailTemplateManager,

    // Services
    PreferencesService, EmailService,

    // Resolve
    obj, type, asInter

  ) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        forms: [],
        emailTemplates: [],
        customMailTemplate: undefined,
        subject: "",
        model: '',
        emailCompany: false,
        asInter: asInter || false,
        withInter: false,
        // Methods
        setValue: setValue,
        cancel: cancel,
        validate: validate,
        hasAddedMails: hasAddedMails,
        isValid: isValid,
        getObjLabel: getObjLabel,
        removeEmail: removeEmail,
        addEmail: addEmail
      })
      init()
    }

    function getObjLabel () {
      switch (type) {
        case 'invoice':
          return 'la facture'
        case 'quote':
          return 'le devis'
        case 'creditnote':
          return "l'avoir"
      }
    }

    function init () {
      EmailService.checkCompanyInfo().then((response) => {
        self.emailCompany = response.data.activateEmailSMTP && response.data.emailIsConnected
      })
      self.displayChangeStatus = obj.status === 'validated'
      self.status = self.displayChangeStatus
      self.mail = true
      self.print = false
      // Si un email par défaut est défini, on prend seulement celui-là
      if (obj.defaultClientEmail) {
        self.emails = [obj.defaultClientEmail]
      } else {
        self.emails = angular.copy(_.get(obj, 'client.emails', []))
        self.contacts = angular.copy(_.get(obj, 'client.contacts', []))
          .filter(Boolean) // Remove undefined
          .map(contact => contact.defaultEmail?.value) // Only store emails
          .filter(Boolean) // Remove undefined
        if (self.contacts) self.emails = self.emails.concat(self.contacts)
      }
      if (!self.emails.length) self.emails.push('')
      var defaultTemplateManager, templateManager
      switch (type) {
        case 'invoice':
          defaultTemplateManager = DefaultInvoiceTemplateManager
          templateManager = InvoiceTemplateManager
          self.subject = 'Votre facture'
          break
        case 'quote':
          defaultTemplateManager = DefaultQuoteTemplateManager
          templateManager = QuoteTemplateManager
          self.subject = 'Votre devis'
          break
        case 'creditnote':
          defaultTemplateManager = DefaultCreditNoteTemplateManager
          templateManager = CreditNoteTemplateManager
          self.subject = 'Votre avoir'
          break
      }
      defaultTemplateManager.get().then(function (def) {
        var defaultTemplates = def.data
        templateManager.get().then(function (custom) {
          self.templates = defaultTemplates.concat(custom.data)
          if (self.templates && self.templates.length) self.mailTemplate = self.templates[0]
          self.loading = false
        })
      })

      EmailTemplateManager.get().then(function (data) {
        data.data.unshift({label: 'Email par défaut', _id: undefined})
        self.customMailTemplate = {label: 'Email par défaut', _id: undefined}
        self.emailTemplates = data.data
      })
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        self.mail = !generalPrefs.settings.sendInvoiceByEmail
      })
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        if (companyPrefs.companyInfo.emailCopy && companyPrefs.companyInfo.emailCopy.length > 0) {
          self.emails.push(companyPrefs.companyInfo.emailCopy)
        }
      })
    }

    function setValue (opt) {
      self[opt] = !self[opt]
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function hasAddedMails () {
      if (!self.emails || !self.emails.length) return
      var hasAdded = _.find(self.emails, function (email) {
        return email.added === true
      })
      return !!hasAdded
    }

    function isValid () {
      var valid = false
      if (self.print || self.status || !self.displayChangeStatus) valid = true
      if (self.mail) {
        return valid && _.get(self, 'emailForm.$valid') && _.get(self, 'emails.length')
      }
      return valid
    }

    function validate () {
      var emails = _(self.emails)
        .filter(function (e) { return !!e })
        .map(function (e) {
          return {origin: 'added', email: e, added: true}
        })
        .value()

      $uibModalInstance.close({
        print: self.print,
        mail: self.mail,
        mailTemplate: self.mailTemplate,
        emails: emails,
        status: self.status,
        customMailTemplate: _.get(self, 'customMailTemplate._id'),
        model: self.model,
        subject: self.subject,
        withInter: self.withInter
      })
    }

    function removeEmail (index) {
      self.emails.splice(index, 1)
    }

    function addEmail () {
      self.emails.push('')
    }
  }
})(window.angular, window._)
